import Header from "@/components/header";
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  InputBase,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import "leaflet/dist/leaflet.css";
import { useEffect } from "react";

import * as Yup from "yup";

import CustomStepper from "@/components/stepper";
import PersianUtil from "@/services/persianUtiles/numberPersianUtiles";
import useCheckNationalCode from "@/services/verification/hooks/useCheckNationalCode";
import { useGetVerification } from "@/services/verification/hooks/useGetVerification";
import { UpdateMerchantVerification } from "@/services/verification/type";
import checkNationalCodeValidation from "@/utilities/helper/checkNationalCodeValidation";
import { IconAsterisk } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { steppersData } from "./type";
import useIsSmall from "@/hooks/useIsSmall";

const signUpSchema = Yup.object({
  nationalCode: Yup.string()
    .required("کد ملی را وارد نمایید")
    .test(
      "national_code_validation",
      "کد ملی را به درستی واردنمایید",
      function (value) {
        return checkNationalCodeValidation(value as string);
      }
    ),
});

function VerificationMerchant() {
  const { mutate, isLoading } = useCheckNationalCode();
  const navigate = useNavigate();
  const isSmall = useIsSmall();
  const form = useForm<UpdateMerchantVerification>({
    validate: yupResolver(signUpSchema),
  });

  const { data: verification, isLoading:
    verificationLoading } =
    useGetVerification({ isAdmin: true });

  const { setValues } = form;

  useEffect(() => {
    setValues({
      nationalCode: verification?.nationalCode,
    });
  }, [verification, setValues]);

  const submit = (values: UpdateMerchantVerification) => {
    // updateMerchant(values);
    mutate(
      {
        nationalCode: values?.nationalCode,
      },
      {
        onSuccess() {
          navigate("IDImage");
        },
      }
    );
  };

  return (
    <>
      <Header title="تایید هویت" showBack route="/dashboard/profile" />
      <Container w="100%" size="full">
        <Title order={4}> تایید هویت </Title>
      </Container>
      <Container size="sm" w="100%">
        <Stack mih={isSmall ? "calc(100svh - 120px)" : ""} mt="xl">
          <CustomStepper steppers={steppersData} active={0} />
          <Stack flex={1}>
            <Stack flex={1} px="md">
              <Alert>
                <Stack ta="center">
                  <Text size="xs">
                    کاربر گرامی ، برای استفاده از تمام ویژگی های سامانه ، ابتدا
                    نسبت به احراز هویت خود اقدام نمایید.
                  </Text>
                  <Text size="xs" ta="center" fw="800">
                    <IconAsterisk stroke={1} color="red" size={10} />
                    دقت فرمایید که{" "}
                    <Text c="blue" span>
                      کد ملی
                    </Text>{" "}
                    و{" "}
                    <Text c="blue" span>
                      شماره تلفنی
                    </Text>{" "}
                    که با آن در سامانه ثبت نام کرده ایید باید متعلق به خود شما
                    باشد.
                  </Text>
                </Stack>
              </Alert>
              <Box>
                <form id="information" onSubmit={form.onSubmit(submit)}>
                  <Grid>
                    <Grid.Col span={{ base: 12 }}>
                      <InputBase
                        size="md"
                        type="tel"
                        dir="ltr"
                        disabled={verificationLoading}
                        description="کد ملی خود را وارد نمایید"
                        styles={{
                          input: {
                            textAlign: "left",
                            paddingLeft: "16px",
                          },
                        }}
                        value={form.values.nationalCode || ""}
                        maxLength={10}
                        label="کد ملی"
                        withAsterisk
                        onChange={(e) => {
                          form.setValues({
                            nationalCode: PersianUtil.currentNumberToEnglish(
                              e.target.value
                            ),
                          });
                        }}
                        error={form.errors.nationalCode}
                      />
                    </Grid.Col>
                  </Grid>
                </form>
              </Box>
            </Stack>
            <Stack px="md" mb="lg">
              <Button
                type="submit"
                form="information"
                size="md"
                loading={isLoading || verificationLoading}
                fullWidth
              >
                ادامه{" "}
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </>
  );
}

export default VerificationMerchant;
